import moment from "moment";


export const getFriendlyDateLabel = (inputDateStr = moment()) => {
    const inputDate = moment(inputDateStr, 'MM/DD/YYYY');
    const today = moment();
    const tomorrow = moment().add(1, 'day');

    if (inputDate.isSame(today, 'day')) {
        return `Today, ${today.format('ddd D')}`; // e.g., "Today, Tue 27"
    } else if (inputDate.isSame(tomorrow, 'day')) {
        return `Tomorrow, ${tomorrow.format('ddd D')}`; // e.g., "Tomorrow, Wed 28"
    } else {
        return inputDate.format('dddd, MMM D'); // e.g., "Thursday, May 30"
    }
}